import * as React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps, withState } from 'recompose';
import { Field, change, formValueSelector } from 'redux-form';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { FormUpload } from '@inqool/uas-web-core/es/components/controls/Upload';
import FileUploadIcon from 'material-ui/svg-icons/file/file-upload';

import { editFile, saveFile } from '@components/form/Upload/_uploadActions';
import * as T from '@components/form/Upload/_uploadTypes';
import { withNotifications } from '@components/hoc/withNotifications';
import { Loader } from '@components/loader';

export const Preview = props =>
  props.disabled ? (
    <span>Nebyl zvolen žádný soubor</span>
  ) : (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
      }}
    >
      <FileUploadIcon /> {props.overwriteId ? 'Přepsat soubor' : 'Vybrat'}
    </span>
  );

const Upload: React.SFC<T.OutterProps & T.InnerProps> = ({
  style,
  overwriteId,
  fileRef,
  loader,
  editing,
  handleEdit,
  ...props
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      ...style
    }}
  >
    {loader && <Loader />}
    <FormUpload
      {...props}
      overwriteId={overwriteId}
      url="/metropolis/api/files/"
      View={withProps({ overwriteId })(Preview)}
      fullWidth={true}
    />
    {fileRef && fileRef.contentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? (
      <Button
        label={editing ? 'Uložit' : 'Editovat'}
        primary={true}
        style={{ margin: '0 0 0 16px' }}
        onClick={handleEdit}
      />
    ) : (
      <></>
    )}
  </div>
);

export default compose<any, any>(
  connect(
    (state: any, { meta, input }: any) => {
      return {
        fileRef: formValueSelector(meta.form)(state, input.name),
        eventId: formValueSelector('module-events')(state, 'id')
      };
    },
    dispatch => {
      return {
        changeFieldValue: value =>
          dispatch(change('module-events-record-document-create-add-attachment', 'attachment.file', value))
      };
    }
  ),
  withNotifications({ editFile, saveFile }),
  withState('editing', 'setEditing', false),
  withState<{}, boolean, string, string>('loader', 'setLoader', false),
  withProps(({ overwriteId }) => {
    return { overwriteId };
  }),
  withHandlers({
    handleEdit: ({
      editFileNotify,
      saveFileNotify,
      fileRef,
      setLoader,
      editing,
      setEditing,
      eventId,
      overwriteId,
      changeFieldValue
    }) => async () => {
      if (editing) {
        setLoader(true);
        const result = await saveFileNotify({ fileId: fileRef.id, eventId });
        changeFieldValue(result);
        setLoader(false);

        if (result) {
          setEditing(false);
        }
        if (overwriteId !== null) {
          location.reload();
        }
      } else {
        setLoader(true);
        const result = await editFileNotify(fileRef.id);
        setLoader(false);

        if (result) {
          window.open(result.url, '_blank');
          setEditing(true);
        }
      }
    }
  })
)(Upload);

export class UploadField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/Upload/Upload.tsx